
import Artwork from 'parts/Artwork';

const MovieArtwork = props => (
  <Artwork {...props} />
);

export default MovieArtwork;
